import { DEFAULT_MAX_ITEM_WIDTH, DEFAULT_GRID_COLUMN_WIDTH } from './constants.mjs';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const RowItemCore = styled('div')(({ fullWidth })=>({
        maxWidth: fullWidth ? DEFAULT_MAX_ITEM_WIDTH : DEFAULT_GRID_COLUMN_WIDTH
    }));

export { RowItemCore };
//# sourceMappingURL=RowItem.mjs.map
